import { AxiosInstance } from 'axios'

import { DefaultApiFactory } from '../generated/user-api'

export const userApiDefaultApiFactory = (instance: AxiosInstance) => {
  return DefaultApiFactory(undefined, '', instance)
}
